import React from 'react'

import Select from '.'

const WrappedSelect = React.forwardRef(Select)

export default WrappedSelect
